/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var Object_pb = require('./Object_pb.js');
goog.exportSymbol('proto.vision.market.proto.GetBaseKbar', null, global);
goog.exportSymbol('proto.vision.market.proto.GetKbarRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.GetLastDayKbar', null, global);
goog.exportSymbol('proto.vision.market.proto.GetProduct', null, global);
goog.exportSymbol('proto.vision.market.proto.GetProductRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.GetTarget', null, global);
goog.exportSymbol('proto.vision.market.proto.GetTargetRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.GetTick', null, global);
goog.exportSymbol('proto.vision.market.proto.GetTickRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.Kbar', null, global);
goog.exportSymbol('proto.vision.market.proto.MarketLogin', null, global);
goog.exportSymbol('proto.vision.market.proto.MarketLoginReq', null, global);
goog.exportSymbol('proto.vision.market.proto.MarketLoginRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.Product', null, global);
goog.exportSymbol('proto.vision.market.proto.SubKbar', null, global);
goog.exportSymbol('proto.vision.market.proto.SubKbarRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.SubTarget', null, global);
goog.exportSymbol('proto.vision.market.proto.SubTargetRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.SubTick', null, global);
goog.exportSymbol('proto.vision.market.proto.SubTickAll', null, global);
goog.exportSymbol('proto.vision.market.proto.SubTickAllRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.SubTickRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.Target', null, global);
goog.exportSymbol('proto.vision.market.proto.Tick', null, global);
goog.exportSymbol('proto.vision.market.proto.TickDelta', null, global);
goog.exportSymbol('proto.vision.market.proto.TimeSeq', null, global);
goog.exportSymbol('proto.vision.market.proto.TimeSeqReq', null, global);
goog.exportSymbol('proto.vision.market.proto.TimeSeqRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.TimeSeqSet', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.MarketLoginReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.MarketLoginReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.MarketLoginReq.displayName = 'proto.vision.market.proto.MarketLoginReq';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.MarketLoginReq.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.MarketLoginReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.MarketLoginReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.MarketLoginReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    broker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    account: jspb.Message.getFieldWithDefault(msg, 2, ""),
    password: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.MarketLoginReq}
 */
proto.vision.market.proto.MarketLoginReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.MarketLoginReq;
  return proto.vision.market.proto.MarketLoginReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.MarketLoginReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.MarketLoginReq}
 */
proto.vision.market.proto.MarketLoginReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.MarketLoginReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.MarketLoginReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.MarketLoginReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.MarketLoginReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccount();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string broker = 1;
 * @return {string}
 */
proto.vision.market.proto.MarketLoginReq.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.vision.market.proto.MarketLoginReq.prototype.setBroker = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account = 2;
 * @return {string}
 */
proto.vision.market.proto.MarketLoginReq.prototype.getAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.vision.market.proto.MarketLoginReq.prototype.setAccount = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string password = 3;
 * @return {string}
 */
proto.vision.market.proto.MarketLoginReq.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.vision.market.proto.MarketLoginReq.prototype.setPassword = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.MarketLogin = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.MarketLogin, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.MarketLogin.displayName = 'proto.vision.market.proto.MarketLogin';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.MarketLogin.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.MarketLogin.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.MarketLogin} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.MarketLogin.toObject = function(includeInstance, msg) {
  var f, obj = {
    broker: jspb.Message.getFieldWithDefault(msg, 10, ""),
    account: jspb.Message.getFieldWithDefault(msg, 11, ""),
    password: jspb.Message.getFieldWithDefault(msg, 12, ""),
    tradingDay: jspb.Message.getFieldWithDefault(msg, 13, ""),
    loginTime: jspb.Message.getFieldWithDefault(msg, 15, ""),
    userName: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.MarketLogin}
 */
proto.vision.market.proto.MarketLogin.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.MarketLogin;
  return proto.vision.market.proto.MarketLogin.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.MarketLogin} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.MarketLogin}
 */
proto.vision.market.proto.MarketLogin.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccount(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradingDay(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoginTime(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.MarketLogin.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.MarketLogin.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.MarketLogin} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.MarketLogin.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getAccount();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTradingDay();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getLoginTime();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional string broker = 10;
 * @return {string}
 */
proto.vision.market.proto.MarketLogin.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.vision.market.proto.MarketLogin.prototype.setBroker = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string account = 11;
 * @return {string}
 */
proto.vision.market.proto.MarketLogin.prototype.getAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.vision.market.proto.MarketLogin.prototype.setAccount = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string password = 12;
 * @return {string}
 */
proto.vision.market.proto.MarketLogin.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.vision.market.proto.MarketLogin.prototype.setPassword = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string trading_day = 13;
 * @return {string}
 */
proto.vision.market.proto.MarketLogin.prototype.getTradingDay = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.vision.market.proto.MarketLogin.prototype.setTradingDay = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string login_time = 15;
 * @return {string}
 */
proto.vision.market.proto.MarketLogin.prototype.getLoginTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.vision.market.proto.MarketLogin.prototype.setLoginTime = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string user_name = 16;
 * @return {string}
 */
proto.vision.market.proto.MarketLogin.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.vision.market.proto.MarketLogin.prototype.setUserName = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.MarketLoginRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.MarketLoginRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.MarketLoginRsp.displayName = 'proto.vision.market.proto.MarketLoginRsp';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.MarketLoginRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.MarketLoginRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.MarketLoginRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.MarketLoginRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.vision.market.proto.MarketLogin.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.MarketLoginRsp}
 */
proto.vision.market.proto.MarketLoginRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.MarketLoginRsp;
  return proto.vision.market.proto.MarketLoginRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.MarketLoginRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.MarketLoginRsp}
 */
proto.vision.market.proto.MarketLoginRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new Object_pb.Error;
      reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 10:
      var value = new proto.vision.market.proto.MarketLogin;
      reader.readMessage(value,proto.vision.market.proto.MarketLogin.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.MarketLoginRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.MarketLoginRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.MarketLoginRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.MarketLoginRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      Object_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.vision.market.proto.MarketLogin.serializeBinaryToWriter
    );
  }
};


/**
 * optional proto.Error error = 2;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.MarketLoginRsp.prototype.getError = function() {
  return /** @type{?proto.proto.Error} */ (
    jspb.Message.getWrapperField(this, Object_pb.Error, 2));
};


/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.MarketLoginRsp.prototype.setError = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.vision.market.proto.MarketLoginRsp.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.MarketLoginRsp.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional MarketLogin data = 10;
 * @return {?proto.vision.market.proto.MarketLogin}
 */
proto.vision.market.proto.MarketLoginRsp.prototype.getData = function() {
  return /** @type{?proto.vision.market.proto.MarketLogin} */ (
    jspb.Message.getWrapperField(this, proto.vision.market.proto.MarketLogin, 10));
};


/** @param {?proto.vision.market.proto.MarketLogin|undefined} value */
proto.vision.market.proto.MarketLoginRsp.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 10, value);
};


proto.vision.market.proto.MarketLoginRsp.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.MarketLoginRsp.prototype.hasData = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.Product = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.Product, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.Product.displayName = 'proto.vision.market.proto.Product';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.Product.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.Product.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.Product} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.Product.toObject = function(includeInstance, msg) {
  var f, obj = {
    identity: jspb.Message.getFieldWithDefault(msg, 18, 0),
    productCode: jspb.Message.getFieldWithDefault(msg, 17, ""),
    productId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    productName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    productClass: jspb.Message.getFieldWithDefault(msg, 3, 0),
    exchangeId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    currencyId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    orderMarketMax: jspb.Message.getFieldWithDefault(msg, 6, 0),
    orderMarketMin: jspb.Message.getFieldWithDefault(msg, 7, 0),
    orderLimitMax: jspb.Message.getFieldWithDefault(msg, 8, 0),
    orderLimitMin: jspb.Message.getFieldWithDefault(msg, 9, 0),
    positionType: jspb.Message.getFieldWithDefault(msg, 10, 0),
    positionDateType: jspb.Message.getFieldWithDefault(msg, 11, 0),
    multiple: jspb.Message.getFieldWithDefault(msg, 12, 0),
    priceTick: +jspb.Message.getFieldWithDefault(msg, 13, 0.0),
    stamp: jspb.Message.getFieldWithDefault(msg, 14, 0),
    productView: jspb.Message.getFieldWithDefault(msg, 15, ""),
    dst: jspb.Message.getFieldWithDefault(msg, 16, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.Product}
 */
proto.vision.market.proto.Product.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.Product;
  return proto.vision.market.proto.Product.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.Product} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.Product}
 */
proto.vision.market.proto.Product.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 18:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setIdentity(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductCode(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setProductClass(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExchangeId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCurrencyId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOrderMarketMax(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOrderMarketMin(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOrderLimitMax(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOrderLimitMin(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPositionType(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPositionDateType(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMultiple(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceTick(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStamp(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductView(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDst(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.Product.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.Product.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.Product} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.Product.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentity();
  if (f !== 0) {
    writer.writeUint32(
      18,
      f
    );
  }
  f = message.getProductCode();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProductName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProductClass();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getExchangeId();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getCurrencyId();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getOrderMarketMax();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getOrderMarketMin();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getOrderLimitMax();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getOrderLimitMin();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getPositionType();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getPositionDateType();
  if (f !== 0) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = message.getMultiple();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getPriceTick();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getStamp();
  if (f !== 0) {
    writer.writeUint32(
      14,
      f
    );
  }
  f = message.getProductView();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getDst();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
};


/**
 * optional uint32 identity = 18;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getIdentity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.vision.market.proto.Product.prototype.setIdentity = function(value) {
  jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional string product_code = 17;
 * @return {string}
 */
proto.vision.market.proto.Product.prototype.getProductCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/** @param {string} value */
proto.vision.market.proto.Product.prototype.setProductCode = function(value) {
  jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string product_id = 1;
 * @return {string}
 */
proto.vision.market.proto.Product.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.vision.market.proto.Product.prototype.setProductId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string product_name = 2;
 * @return {string}
 */
proto.vision.market.proto.Product.prototype.getProductName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.vision.market.proto.Product.prototype.setProductName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 product_class = 3;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getProductClass = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.vision.market.proto.Product.prototype.setProductClass = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 exchange_id = 4;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getExchangeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.vision.market.proto.Product.prototype.setExchangeId = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 currency_id = 5;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getCurrencyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.vision.market.proto.Product.prototype.setCurrencyId = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 order_market_max = 6;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getOrderMarketMax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.vision.market.proto.Product.prototype.setOrderMarketMax = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 order_market_min = 7;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getOrderMarketMin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.vision.market.proto.Product.prototype.setOrderMarketMin = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 order_limit_max = 8;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getOrderLimitMax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.vision.market.proto.Product.prototype.setOrderLimitMax = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional uint32 order_limit_min = 9;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getOrderLimitMin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.vision.market.proto.Product.prototype.setOrderLimitMin = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional uint32 position_type = 10;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getPositionType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.vision.market.proto.Product.prototype.setPositionType = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional uint32 position_date_type = 11;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getPositionDateType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.vision.market.proto.Product.prototype.setPositionDateType = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional uint32 multiple = 12;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getMultiple = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.vision.market.proto.Product.prototype.setMultiple = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional double price_tick = 13;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getPriceTick = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 13, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Product.prototype.setPriceTick = function(value) {
  jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional uint32 stamp = 14;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getStamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.vision.market.proto.Product.prototype.setStamp = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string product_view = 15;
 * @return {string}
 */
proto.vision.market.proto.Product.prototype.getProductView = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.vision.market.proto.Product.prototype.setProductView = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional bool dst = 16;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.vision.market.proto.Product.prototype.getDst = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 16, false));
};


/** @param {boolean} value */
proto.vision.market.proto.Product.prototype.setDst = function(value) {
  jspb.Message.setProto3BooleanField(this, 16, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.Target = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.Target, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.Target.displayName = 'proto.vision.market.proto.Target';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.Target.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.Target.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.Target} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.Target.toObject = function(includeInstance, msg) {
  var f, obj = {
    identity: jspb.Message.getFieldWithDefault(msg, 10, 0),
    targetCode: jspb.Message.getFieldWithDefault(msg, 8, ""),
    targetView: jspb.Message.getFieldWithDefault(msg, 9, ""),
    targetId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    targetName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dateCreate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    dateOpen: jspb.Message.getFieldWithDefault(msg, 4, ""),
    statePhase: jspb.Message.getFieldWithDefault(msg, 5, 0),
    stateTrading: jspb.Message.getFieldWithDefault(msg, 6, false),
    stamp: jspb.Message.getFieldWithDefault(msg, 7, 0),
    dateExpire: jspb.Message.getFieldWithDefault(msg, 21, ""),
    dateDeliveryStart: jspb.Message.getFieldWithDefault(msg, 22, ""),
    dateDeliveryEnd: jspb.Message.getFieldWithDefault(msg, 23, ""),
    deliveryMonth: jspb.Message.getFieldWithDefault(msg, 24, 0),
    marginSideAlgor: jspb.Message.getFieldWithDefault(msg, 25, false),
    marginLong: +jspb.Message.getFieldWithDefault(msg, 26, 0.0),
    marginShort: +jspb.Message.getFieldWithDefault(msg, 27, 0.0),
    productId: jspb.Message.getFieldWithDefault(msg, 29, ""),
    productClass: jspb.Message.getFieldWithDefault(msg, 30, 0),
    exchangeId: jspb.Message.getFieldWithDefault(msg, 31, 0),
    multiple: jspb.Message.getFieldWithDefault(msg, 32, 0),
    priceTick: +jspb.Message.getFieldWithDefault(msg, 33, 0.0),
    marginLongValue: +jspb.Message.getFieldWithDefault(msg, 34, 0.0),
    marginShortValue: +jspb.Message.getFieldWithDefault(msg, 35, 0.0),
    commissionLong: +jspb.Message.getFieldWithDefault(msg, 36, 0.0),
    commissionShort: +jspb.Message.getFieldWithDefault(msg, 37, 0.0),
    commissionLongValue: +jspb.Message.getFieldWithDefault(msg, 38, 0.0),
    commissionShortValue: +jspb.Message.getFieldWithDefault(msg, 39, 0.0),
    priceStrick: +jspb.Message.getFieldWithDefault(msg, 41, 0.0),
    optionType: jspb.Message.getFieldWithDefault(msg, 42, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.Target}
 */
proto.vision.market.proto.Target.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.Target;
  return proto.vision.market.proto.Target.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.Target} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.Target}
 */
proto.vision.market.proto.Target.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 10:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setIdentity(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetCode(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetView(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateCreate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateOpen(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatePhase(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStateTrading(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStamp(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateExpire(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateDeliveryStart(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateDeliveryEnd(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDeliveryMonth(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarginSideAlgor(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMarginLong(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMarginShort(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setProductClass(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExchangeId(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMultiple(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceTick(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMarginLongValue(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMarginShortValue(value);
      break;
    case 36:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCommissionLong(value);
      break;
    case 37:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCommissionShort(value);
      break;
    case 38:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCommissionLongValue(value);
      break;
    case 39:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCommissionShortValue(value);
      break;
    case 41:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceStrick(value);
      break;
    case 42:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOptionType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.Target.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.Target.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.Target} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.Target.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentity();
  if (f !== 0) {
    writer.writeUint64(
      10,
      f
    );
  }
  f = message.getTargetCode();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTargetView();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getTargetId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTargetName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDateCreate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDateOpen();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatePhase();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getStateTrading();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getStamp();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getDateExpire();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getDateDeliveryStart();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getDateDeliveryEnd();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getDeliveryMonth();
  if (f !== 0) {
    writer.writeUint32(
      24,
      f
    );
  }
  f = message.getMarginSideAlgor();
  if (f) {
    writer.writeBool(
      25,
      f
    );
  }
  f = message.getMarginLong();
  if (f !== 0.0) {
    writer.writeDouble(
      26,
      f
    );
  }
  f = message.getMarginShort();
  if (f !== 0.0) {
    writer.writeDouble(
      27,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getProductClass();
  if (f !== 0) {
    writer.writeUint32(
      30,
      f
    );
  }
  f = message.getExchangeId();
  if (f !== 0) {
    writer.writeUint32(
      31,
      f
    );
  }
  f = message.getMultiple();
  if (f !== 0) {
    writer.writeUint32(
      32,
      f
    );
  }
  f = message.getPriceTick();
  if (f !== 0.0) {
    writer.writeDouble(
      33,
      f
    );
  }
  f = message.getMarginLongValue();
  if (f !== 0.0) {
    writer.writeDouble(
      34,
      f
    );
  }
  f = message.getMarginShortValue();
  if (f !== 0.0) {
    writer.writeDouble(
      35,
      f
    );
  }
  f = message.getCommissionLong();
  if (f !== 0.0) {
    writer.writeDouble(
      36,
      f
    );
  }
  f = message.getCommissionShort();
  if (f !== 0.0) {
    writer.writeDouble(
      37,
      f
    );
  }
  f = message.getCommissionLongValue();
  if (f !== 0.0) {
    writer.writeDouble(
      38,
      f
    );
  }
  f = message.getCommissionShortValue();
  if (f !== 0.0) {
    writer.writeDouble(
      39,
      f
    );
  }
  f = message.getPriceStrick();
  if (f !== 0.0) {
    writer.writeDouble(
      41,
      f
    );
  }
  f = message.getOptionType();
  if (f) {
    writer.writeBool(
      42,
      f
    );
  }
};


/**
 * optional uint64 identity = 10;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getIdentity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.vision.market.proto.Target.prototype.setIdentity = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string target_code = 8;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getTargetCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.vision.market.proto.Target.prototype.setTargetCode = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string target_view = 9;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getTargetView = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.vision.market.proto.Target.prototype.setTargetView = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string target_id = 1;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getTargetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.vision.market.proto.Target.prototype.setTargetId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string target_name = 2;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getTargetName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.vision.market.proto.Target.prototype.setTargetName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string date_create = 3;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getDateCreate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.vision.market.proto.Target.prototype.setDateCreate = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string date_open = 4;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getDateOpen = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.vision.market.proto.Target.prototype.setDateOpen = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 state_phase = 5;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getStatePhase = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.vision.market.proto.Target.prototype.setStatePhase = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool state_trading = 6;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.vision.market.proto.Target.prototype.getStateTrading = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 6, false));
};


/** @param {boolean} value */
proto.vision.market.proto.Target.prototype.setStateTrading = function(value) {
  jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional uint32 stamp = 7;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getStamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.vision.market.proto.Target.prototype.setStamp = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string date_expire = 21;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getDateExpire = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/** @param {string} value */
proto.vision.market.proto.Target.prototype.setDateExpire = function(value) {
  jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string date_delivery_start = 22;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getDateDeliveryStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/** @param {string} value */
proto.vision.market.proto.Target.prototype.setDateDeliveryStart = function(value) {
  jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string date_delivery_end = 23;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getDateDeliveryEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/** @param {string} value */
proto.vision.market.proto.Target.prototype.setDateDeliveryEnd = function(value) {
  jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional uint32 delivery_month = 24;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getDeliveryMonth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/** @param {number} value */
proto.vision.market.proto.Target.prototype.setDeliveryMonth = function(value) {
  jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional bool margin_side_algor = 25;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.vision.market.proto.Target.prototype.getMarginSideAlgor = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 25, false));
};


/** @param {boolean} value */
proto.vision.market.proto.Target.prototype.setMarginSideAlgor = function(value) {
  jspb.Message.setProto3BooleanField(this, 25, value);
};


/**
 * optional double margin_long = 26;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getMarginLong = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 26, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Target.prototype.setMarginLong = function(value) {
  jspb.Message.setProto3FloatField(this, 26, value);
};


/**
 * optional double margin_short = 27;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getMarginShort = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 27, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Target.prototype.setMarginShort = function(value) {
  jspb.Message.setProto3FloatField(this, 27, value);
};


/**
 * optional string product_id = 29;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/** @param {string} value */
proto.vision.market.proto.Target.prototype.setProductId = function(value) {
  jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional uint32 product_class = 30;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getProductClass = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/** @param {number} value */
proto.vision.market.proto.Target.prototype.setProductClass = function(value) {
  jspb.Message.setProto3IntField(this, 30, value);
};


/**
 * optional uint32 exchange_id = 31;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getExchangeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 31, 0));
};


/** @param {number} value */
proto.vision.market.proto.Target.prototype.setExchangeId = function(value) {
  jspb.Message.setProto3IntField(this, 31, value);
};


/**
 * optional uint32 multiple = 32;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getMultiple = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/** @param {number} value */
proto.vision.market.proto.Target.prototype.setMultiple = function(value) {
  jspb.Message.setProto3IntField(this, 32, value);
};


/**
 * optional double price_tick = 33;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getPriceTick = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 33, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Target.prototype.setPriceTick = function(value) {
  jspb.Message.setProto3FloatField(this, 33, value);
};


/**
 * optional double margin_long_value = 34;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getMarginLongValue = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 34, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Target.prototype.setMarginLongValue = function(value) {
  jspb.Message.setProto3FloatField(this, 34, value);
};


/**
 * optional double margin_short_value = 35;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getMarginShortValue = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 35, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Target.prototype.setMarginShortValue = function(value) {
  jspb.Message.setProto3FloatField(this, 35, value);
};


/**
 * optional double commission_long = 36;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getCommissionLong = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 36, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Target.prototype.setCommissionLong = function(value) {
  jspb.Message.setProto3FloatField(this, 36, value);
};


/**
 * optional double commission_short = 37;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getCommissionShort = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 37, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Target.prototype.setCommissionShort = function(value) {
  jspb.Message.setProto3FloatField(this, 37, value);
};


/**
 * optional double commission_long_value = 38;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getCommissionLongValue = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 38, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Target.prototype.setCommissionLongValue = function(value) {
  jspb.Message.setProto3FloatField(this, 38, value);
};


/**
 * optional double commission_short_value = 39;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getCommissionShortValue = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 39, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Target.prototype.setCommissionShortValue = function(value) {
  jspb.Message.setProto3FloatField(this, 39, value);
};


/**
 * optional double price_strick = 41;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getPriceStrick = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 41, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Target.prototype.setPriceStrick = function(value) {
  jspb.Message.setProto3FloatField(this, 41, value);
};


/**
 * optional bool option_type = 42;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.vision.market.proto.Target.prototype.getOptionType = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 42, false));
};


/** @param {boolean} value */
proto.vision.market.proto.Target.prototype.setOptionType = function(value) {
  jspb.Message.setProto3BooleanField(this, 42, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.GetProduct = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.GetProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.GetProduct.displayName = 'proto.vision.market.proto.GetProduct';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.GetProduct.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.GetProduct.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.GetProduct} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetProduct.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    productId: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.GetProduct}
 */
proto.vision.market.proto.GetProduct.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.GetProduct;
  return proto.vision.market.proto.GetProduct.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.GetProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.GetProduct}
 */
proto.vision.market.proto.GetProduct.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUserId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.GetProduct.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.GetProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.GetProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetProduct.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional uint64 user_id = 1;
 * @return {number}
 */
proto.vision.market.proto.GetProduct.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.vision.market.proto.GetProduct.prototype.setUserId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string product_id = 10;
 * @return {string}
 */
proto.vision.market.proto.GetProduct.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.vision.market.proto.GetProduct.prototype.setProductId = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.GetProductRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.GetProductRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.GetProductRsp.displayName = 'proto.vision.market.proto.GetProductRsp';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.GetProductRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.GetProductRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.GetProductRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetProductRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.vision.market.proto.Product.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.GetProductRsp}
 */
proto.vision.market.proto.GetProductRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.GetProductRsp;
  return proto.vision.market.proto.GetProductRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.GetProductRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.GetProductRsp}
 */
proto.vision.market.proto.GetProductRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new Object_pb.Error;
      reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 10:
      var value = new proto.vision.market.proto.Product;
      reader.readMessage(value,proto.vision.market.proto.Product.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.GetProductRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.GetProductRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.GetProductRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetProductRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      Object_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.vision.market.proto.Product.serializeBinaryToWriter
    );
  }
};


/**
 * optional proto.Error error = 2;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.GetProductRsp.prototype.getError = function() {
  return /** @type{?proto.proto.Error} */ (
    jspb.Message.getWrapperField(this, Object_pb.Error, 2));
};


/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.GetProductRsp.prototype.setError = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.vision.market.proto.GetProductRsp.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.GetProductRsp.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Product data = 10;
 * @return {?proto.vision.market.proto.Product}
 */
proto.vision.market.proto.GetProductRsp.prototype.getData = function() {
  return /** @type{?proto.vision.market.proto.Product} */ (
    jspb.Message.getWrapperField(this, proto.vision.market.proto.Product, 10));
};


/** @param {?proto.vision.market.proto.Product|undefined} value */
proto.vision.market.proto.GetProductRsp.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 10, value);
};


proto.vision.market.proto.GetProductRsp.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.GetProductRsp.prototype.hasData = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.GetTarget = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.GetTarget, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.GetTarget.displayName = 'proto.vision.market.proto.GetTarget';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.GetTarget.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.GetTarget.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.GetTarget} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetTarget.toObject = function(includeInstance, msg) {
  var f, obj = {
    targetId: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.GetTarget}
 */
proto.vision.market.proto.GetTarget.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.GetTarget;
  return proto.vision.market.proto.GetTarget.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.GetTarget} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.GetTarget}
 */
proto.vision.market.proto.GetTarget.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.GetTarget.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.GetTarget.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.GetTarget} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetTarget.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string target_id = 10;
 * @return {string}
 */
proto.vision.market.proto.GetTarget.prototype.getTargetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.vision.market.proto.GetTarget.prototype.setTargetId = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.GetTargetRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.GetTargetRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.GetTargetRsp.displayName = 'proto.vision.market.proto.GetTargetRsp';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.GetTargetRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.GetTargetRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.GetTargetRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetTargetRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.vision.market.proto.Target.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.GetTargetRsp}
 */
proto.vision.market.proto.GetTargetRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.GetTargetRsp;
  return proto.vision.market.proto.GetTargetRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.GetTargetRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.GetTargetRsp}
 */
proto.vision.market.proto.GetTargetRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new Object_pb.Error;
      reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 10:
      var value = new proto.vision.market.proto.Target;
      reader.readMessage(value,proto.vision.market.proto.Target.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.GetTargetRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.GetTargetRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.GetTargetRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetTargetRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      Object_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.vision.market.proto.Target.serializeBinaryToWriter
    );
  }
};


/**
 * optional proto.Error error = 2;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.GetTargetRsp.prototype.getError = function() {
  return /** @type{?proto.proto.Error} */ (
    jspb.Message.getWrapperField(this, Object_pb.Error, 2));
};


/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.GetTargetRsp.prototype.setError = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.vision.market.proto.GetTargetRsp.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.GetTargetRsp.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Target data = 10;
 * @return {?proto.vision.market.proto.Target}
 */
proto.vision.market.proto.GetTargetRsp.prototype.getData = function() {
  return /** @type{?proto.vision.market.proto.Target} */ (
    jspb.Message.getWrapperField(this, proto.vision.market.proto.Target, 10));
};


/** @param {?proto.vision.market.proto.Target|undefined} value */
proto.vision.market.proto.GetTargetRsp.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 10, value);
};


proto.vision.market.proto.GetTargetRsp.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.GetTargetRsp.prototype.hasData = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.SubTarget = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.SubTarget, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.SubTarget.displayName = 'proto.vision.market.proto.SubTarget';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.SubTarget.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.SubTarget.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.SubTarget} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubTarget.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    productClass: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.SubTarget}
 */
proto.vision.market.proto.SubTarget.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.SubTarget;
  return proto.vision.market.proto.SubTarget.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.SubTarget} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.SubTarget}
 */
proto.vision.market.proto.SubTarget.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUserId(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setProductClass(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.SubTarget.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.SubTarget.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.SubTarget} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubTarget.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getProductClass();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
};


/**
 * optional uint64 user_id = 1;
 * @return {number}
 */
proto.vision.market.proto.SubTarget.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.vision.market.proto.SubTarget.prototype.setUserId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 product_class = 10;
 * @return {number}
 */
proto.vision.market.proto.SubTarget.prototype.getProductClass = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.vision.market.proto.SubTarget.prototype.setProductClass = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.SubTargetRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.SubTargetRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.SubTargetRsp.displayName = 'proto.vision.market.proto.SubTargetRsp';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.SubTargetRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.SubTargetRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.SubTargetRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubTargetRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.vision.market.proto.SubTarget.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.SubTargetRsp}
 */
proto.vision.market.proto.SubTargetRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.SubTargetRsp;
  return proto.vision.market.proto.SubTargetRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.SubTargetRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.SubTargetRsp}
 */
proto.vision.market.proto.SubTargetRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new Object_pb.Error;
      reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 10:
      var value = new proto.vision.market.proto.SubTarget;
      reader.readMessage(value,proto.vision.market.proto.SubTarget.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.SubTargetRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.SubTargetRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.SubTargetRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubTargetRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      Object_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.vision.market.proto.SubTarget.serializeBinaryToWriter
    );
  }
};


/**
 * optional proto.Error error = 2;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.SubTargetRsp.prototype.getError = function() {
  return /** @type{?proto.proto.Error} */ (
    jspb.Message.getWrapperField(this, Object_pb.Error, 2));
};


/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.SubTargetRsp.prototype.setError = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.vision.market.proto.SubTargetRsp.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.SubTargetRsp.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SubTarget data = 10;
 * @return {?proto.vision.market.proto.SubTarget}
 */
proto.vision.market.proto.SubTargetRsp.prototype.getData = function() {
  return /** @type{?proto.vision.market.proto.SubTarget} */ (
    jspb.Message.getWrapperField(this, proto.vision.market.proto.SubTarget, 10));
};


/** @param {?proto.vision.market.proto.SubTarget|undefined} value */
proto.vision.market.proto.SubTargetRsp.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 10, value);
};


proto.vision.market.proto.SubTargetRsp.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.SubTargetRsp.prototype.hasData = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.Tick = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.Tick, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.Tick.displayName = 'proto.vision.market.proto.Tick';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.Tick.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.Tick.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.Tick} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.Tick.toObject = function(includeInstance, msg) {
  var f, obj = {
    volumeAsk1: jspb.Message.getFieldWithDefault(msg, 1, 0),
    volumeAsk2: jspb.Message.getFieldWithDefault(msg, 2, 0),
    volumeAsk3: jspb.Message.getFieldWithDefault(msg, 3, 0),
    volumeAsk4: jspb.Message.getFieldWithDefault(msg, 4, 0),
    volumeAsk5: jspb.Message.getFieldWithDefault(msg, 5, 0),
    volumeBid1: jspb.Message.getFieldWithDefault(msg, 6, 0),
    volumeBid2: jspb.Message.getFieldWithDefault(msg, 7, 0),
    volumeBid3: jspb.Message.getFieldWithDefault(msg, 8, 0),
    volumeBid4: jspb.Message.getFieldWithDefault(msg, 9, 0),
    volumeBid5: jspb.Message.getFieldWithDefault(msg, 10, 0),
    priceAsk1: +jspb.Message.getFieldWithDefault(msg, 21, 0.0),
    priceAsk2: +jspb.Message.getFieldWithDefault(msg, 22, 0.0),
    priceAsk3: +jspb.Message.getFieldWithDefault(msg, 23, 0.0),
    priceAsk4: +jspb.Message.getFieldWithDefault(msg, 24, 0.0),
    priceAsk5: +jspb.Message.getFieldWithDefault(msg, 25, 0.0),
    priceBid1: +jspb.Message.getFieldWithDefault(msg, 26, 0.0),
    priceBid2: +jspb.Message.getFieldWithDefault(msg, 27, 0.0),
    priceBid3: +jspb.Message.getFieldWithDefault(msg, 28, 0.0),
    priceBid4: +jspb.Message.getFieldWithDefault(msg, 29, 0.0),
    priceBid5: +jspb.Message.getFieldWithDefault(msg, 30, 0.0),
    priceLast: +jspb.Message.getFieldWithDefault(msg, 51, 0.0),
    priceOpen: +jspb.Message.getFieldWithDefault(msg, 52, 0.0),
    priceClose: +jspb.Message.getFieldWithDefault(msg, 53, 0.0),
    priceLow: +jspb.Message.getFieldWithDefault(msg, 54, 0.0),
    priceHigh: +jspb.Message.getFieldWithDefault(msg, 55, 0.0),
    priceLowLimit: +jspb.Message.getFieldWithDefault(msg, 56, 0.0),
    priceHighLimit: +jspb.Message.getFieldWithDefault(msg, 57, 0.0),
    priceCloseLast: +jspb.Message.getFieldWithDefault(msg, 58, 0.0),
    priceAverage: +jspb.Message.getFieldWithDefault(msg, 59, 0.0),
    priceSettlement: +jspb.Message.getFieldWithDefault(msg, 65, 0.0),
    priceSettlementLast: +jspb.Message.getFieldWithDefault(msg, 66, 0.0),
    targetId: jspb.Message.getFieldWithDefault(msg, 71, ""),
    exchangeId: jspb.Message.getFieldWithDefault(msg, 72, 0),
    tradingDay: jspb.Message.getFieldWithDefault(msg, 73, ""),
    updateDate: jspb.Message.getFieldWithDefault(msg, 74, ""),
    updateTime: jspb.Message.getFieldWithDefault(msg, 75, ""),
    updateMilli: jspb.Message.getFieldWithDefault(msg, 76, 0),
    position: jspb.Message.getFieldWithDefault(msg, 77, 0),
    volume: jspb.Message.getFieldWithDefault(msg, 78, 0),
    volumeDelta: jspb.Message.getFieldWithDefault(msg, 79, 0),
    amount: +jspb.Message.getFieldWithDefault(msg, 80, 0.0),
    amountDelta: +jspb.Message.getFieldWithDefault(msg, 81, 0.0),
    productClass: jspb.Message.getFieldWithDefault(msg, 82, 0),
    targetCode: jspb.Message.getFieldWithDefault(msg, 83, ""),
    stamp: jspb.Message.getFieldWithDefault(msg, 88, 0),
    source: jspb.Message.getFieldWithDefault(msg, 89, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.Tick}
 */
proto.vision.market.proto.Tick.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.Tick;
  return proto.vision.market.proto.Tick.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.Tick} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.Tick}
 */
proto.vision.market.proto.Tick.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVolumeAsk1(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVolumeAsk2(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVolumeAsk3(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVolumeAsk4(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVolumeAsk5(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVolumeBid1(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVolumeBid2(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVolumeBid3(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVolumeBid4(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVolumeBid5(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceAsk1(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceAsk2(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceAsk3(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceAsk4(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceAsk5(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceBid1(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceBid2(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceBid3(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceBid4(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceBid5(value);
      break;
    case 51:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceLast(value);
      break;
    case 52:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceOpen(value);
      break;
    case 53:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceClose(value);
      break;
    case 54:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceLow(value);
      break;
    case 55:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceHigh(value);
      break;
    case 56:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceLowLimit(value);
      break;
    case 57:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceHighLimit(value);
      break;
    case 58:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceCloseLast(value);
      break;
    case 59:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceAverage(value);
      break;
    case 65:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceSettlement(value);
      break;
    case 66:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceSettlementLast(value);
      break;
    case 71:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetId(value);
      break;
    case 72:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExchangeId(value);
      break;
    case 73:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradingDay(value);
      break;
    case 74:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdateDate(value);
      break;
    case 75:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdateTime(value);
      break;
    case 76:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUpdateMilli(value);
      break;
    case 77:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPosition(value);
      break;
    case 78:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setVolume(value);
      break;
    case 79:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVolumeDelta(value);
      break;
    case 80:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    case 81:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmountDelta(value);
      break;
    case 82:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setProductClass(value);
      break;
    case 83:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetCode(value);
      break;
    case 88:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStamp(value);
      break;
    case 89:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.Tick.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.Tick.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.Tick} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.Tick.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVolumeAsk1();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getVolumeAsk2();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getVolumeAsk3();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getVolumeAsk4();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getVolumeAsk5();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getVolumeBid1();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getVolumeBid2();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getVolumeBid3();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getVolumeBid4();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getVolumeBid5();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getPriceAsk1();
  if (f !== 0.0) {
    writer.writeDouble(
      21,
      f
    );
  }
  f = message.getPriceAsk2();
  if (f !== 0.0) {
    writer.writeDouble(
      22,
      f
    );
  }
  f = message.getPriceAsk3();
  if (f !== 0.0) {
    writer.writeDouble(
      23,
      f
    );
  }
  f = message.getPriceAsk4();
  if (f !== 0.0) {
    writer.writeDouble(
      24,
      f
    );
  }
  f = message.getPriceAsk5();
  if (f !== 0.0) {
    writer.writeDouble(
      25,
      f
    );
  }
  f = message.getPriceBid1();
  if (f !== 0.0) {
    writer.writeDouble(
      26,
      f
    );
  }
  f = message.getPriceBid2();
  if (f !== 0.0) {
    writer.writeDouble(
      27,
      f
    );
  }
  f = message.getPriceBid3();
  if (f !== 0.0) {
    writer.writeDouble(
      28,
      f
    );
  }
  f = message.getPriceBid4();
  if (f !== 0.0) {
    writer.writeDouble(
      29,
      f
    );
  }
  f = message.getPriceBid5();
  if (f !== 0.0) {
    writer.writeDouble(
      30,
      f
    );
  }
  f = message.getPriceLast();
  if (f !== 0.0) {
    writer.writeDouble(
      51,
      f
    );
  }
  f = message.getPriceOpen();
  if (f !== 0.0) {
    writer.writeDouble(
      52,
      f
    );
  }
  f = message.getPriceClose();
  if (f !== 0.0) {
    writer.writeDouble(
      53,
      f
    );
  }
  f = message.getPriceLow();
  if (f !== 0.0) {
    writer.writeDouble(
      54,
      f
    );
  }
  f = message.getPriceHigh();
  if (f !== 0.0) {
    writer.writeDouble(
      55,
      f
    );
  }
  f = message.getPriceLowLimit();
  if (f !== 0.0) {
    writer.writeDouble(
      56,
      f
    );
  }
  f = message.getPriceHighLimit();
  if (f !== 0.0) {
    writer.writeDouble(
      57,
      f
    );
  }
  f = message.getPriceCloseLast();
  if (f !== 0.0) {
    writer.writeDouble(
      58,
      f
    );
  }
  f = message.getPriceAverage();
  if (f !== 0.0) {
    writer.writeDouble(
      59,
      f
    );
  }
  f = message.getPriceSettlement();
  if (f !== 0.0) {
    writer.writeDouble(
      65,
      f
    );
  }
  f = message.getPriceSettlementLast();
  if (f !== 0.0) {
    writer.writeDouble(
      66,
      f
    );
  }
  f = message.getTargetId();
  if (f.length > 0) {
    writer.writeString(
      71,
      f
    );
  }
  f = message.getExchangeId();
  if (f !== 0) {
    writer.writeUint32(
      72,
      f
    );
  }
  f = message.getTradingDay();
  if (f.length > 0) {
    writer.writeString(
      73,
      f
    );
  }
  f = message.getUpdateDate();
  if (f.length > 0) {
    writer.writeString(
      74,
      f
    );
  }
  f = message.getUpdateTime();
  if (f.length > 0) {
    writer.writeString(
      75,
      f
    );
  }
  f = message.getUpdateMilli();
  if (f !== 0) {
    writer.writeUint32(
      76,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeUint64(
      77,
      f
    );
  }
  f = message.getVolume();
  if (f !== 0) {
    writer.writeUint64(
      78,
      f
    );
  }
  f = message.getVolumeDelta();
  if (f !== 0) {
    writer.writeUint32(
      79,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      80,
      f
    );
  }
  f = message.getAmountDelta();
  if (f !== 0.0) {
    writer.writeDouble(
      81,
      f
    );
  }
  f = message.getProductClass();
  if (f !== 0) {
    writer.writeUint32(
      82,
      f
    );
  }
  f = message.getTargetCode();
  if (f.length > 0) {
    writer.writeString(
      83,
      f
    );
  }
  f = message.getStamp();
  if (f !== 0) {
    writer.writeUint32(
      88,
      f
    );
  }
  f = message.getSource();
  if (f !== 0) {
    writer.writeUint32(
      89,
      f
    );
  }
};


/**
 * optional uint32 volume_ask1 = 1;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeAsk1 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeAsk1 = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 volume_ask2 = 2;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeAsk2 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeAsk2 = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 volume_ask3 = 3;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeAsk3 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeAsk3 = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 volume_ask4 = 4;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeAsk4 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeAsk4 = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 volume_ask5 = 5;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeAsk5 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeAsk5 = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 volume_bid1 = 6;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeBid1 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeBid1 = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 volume_bid2 = 7;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeBid2 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeBid2 = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 volume_bid3 = 8;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeBid3 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeBid3 = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional uint32 volume_bid4 = 9;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeBid4 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeBid4 = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional uint32 volume_bid5 = 10;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeBid5 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeBid5 = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional double price_ask1 = 21;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceAsk1 = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 21, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceAsk1 = function(value) {
  jspb.Message.setProto3FloatField(this, 21, value);
};


/**
 * optional double price_ask2 = 22;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceAsk2 = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 22, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceAsk2 = function(value) {
  jspb.Message.setProto3FloatField(this, 22, value);
};


/**
 * optional double price_ask3 = 23;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceAsk3 = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 23, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceAsk3 = function(value) {
  jspb.Message.setProto3FloatField(this, 23, value);
};


/**
 * optional double price_ask4 = 24;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceAsk4 = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 24, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceAsk4 = function(value) {
  jspb.Message.setProto3FloatField(this, 24, value);
};


/**
 * optional double price_ask5 = 25;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceAsk5 = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 25, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceAsk5 = function(value) {
  jspb.Message.setProto3FloatField(this, 25, value);
};


/**
 * optional double price_bid1 = 26;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceBid1 = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 26, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceBid1 = function(value) {
  jspb.Message.setProto3FloatField(this, 26, value);
};


/**
 * optional double price_bid2 = 27;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceBid2 = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 27, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceBid2 = function(value) {
  jspb.Message.setProto3FloatField(this, 27, value);
};


/**
 * optional double price_bid3 = 28;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceBid3 = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 28, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceBid3 = function(value) {
  jspb.Message.setProto3FloatField(this, 28, value);
};


/**
 * optional double price_bid4 = 29;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceBid4 = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 29, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceBid4 = function(value) {
  jspb.Message.setProto3FloatField(this, 29, value);
};


/**
 * optional double price_bid5 = 30;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceBid5 = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 30, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceBid5 = function(value) {
  jspb.Message.setProto3FloatField(this, 30, value);
};


/**
 * optional double price_last = 51;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceLast = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 51, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceLast = function(value) {
  jspb.Message.setProto3FloatField(this, 51, value);
};


/**
 * optional double price_open = 52;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceOpen = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 52, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceOpen = function(value) {
  jspb.Message.setProto3FloatField(this, 52, value);
};


/**
 * optional double price_close = 53;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceClose = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 53, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceClose = function(value) {
  jspb.Message.setProto3FloatField(this, 53, value);
};


/**
 * optional double price_low = 54;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceLow = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 54, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceLow = function(value) {
  jspb.Message.setProto3FloatField(this, 54, value);
};


/**
 * optional double price_high = 55;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceHigh = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 55, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceHigh = function(value) {
  jspb.Message.setProto3FloatField(this, 55, value);
};


/**
 * optional double price_low_limit = 56;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceLowLimit = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 56, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceLowLimit = function(value) {
  jspb.Message.setProto3FloatField(this, 56, value);
};


/**
 * optional double price_high_limit = 57;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceHighLimit = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 57, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceHighLimit = function(value) {
  jspb.Message.setProto3FloatField(this, 57, value);
};


/**
 * optional double price_close_last = 58;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceCloseLast = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 58, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceCloseLast = function(value) {
  jspb.Message.setProto3FloatField(this, 58, value);
};


/**
 * optional double price_average = 59;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceAverage = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 59, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceAverage = function(value) {
  jspb.Message.setProto3FloatField(this, 59, value);
};


/**
 * optional double price_settlement = 65;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceSettlement = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 65, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceSettlement = function(value) {
  jspb.Message.setProto3FloatField(this, 65, value);
};


/**
 * optional double price_settlement_last = 66;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceSettlementLast = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 66, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceSettlementLast = function(value) {
  jspb.Message.setProto3FloatField(this, 66, value);
};


/**
 * optional string target_id = 71;
 * @return {string}
 */
proto.vision.market.proto.Tick.prototype.getTargetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 71, ""));
};


/** @param {string} value */
proto.vision.market.proto.Tick.prototype.setTargetId = function(value) {
  jspb.Message.setProto3StringField(this, 71, value);
};


/**
 * optional uint32 exchange_id = 72;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getExchangeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 72, 0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setExchangeId = function(value) {
  jspb.Message.setProto3IntField(this, 72, value);
};


/**
 * optional string trading_day = 73;
 * @return {string}
 */
proto.vision.market.proto.Tick.prototype.getTradingDay = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 73, ""));
};


/** @param {string} value */
proto.vision.market.proto.Tick.prototype.setTradingDay = function(value) {
  jspb.Message.setProto3StringField(this, 73, value);
};


/**
 * optional string update_date = 74;
 * @return {string}
 */
proto.vision.market.proto.Tick.prototype.getUpdateDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 74, ""));
};


/** @param {string} value */
proto.vision.market.proto.Tick.prototype.setUpdateDate = function(value) {
  jspb.Message.setProto3StringField(this, 74, value);
};


/**
 * optional string update_time = 75;
 * @return {string}
 */
proto.vision.market.proto.Tick.prototype.getUpdateTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 75, ""));
};


/** @param {string} value */
proto.vision.market.proto.Tick.prototype.setUpdateTime = function(value) {
  jspb.Message.setProto3StringField(this, 75, value);
};


/**
 * optional uint32 update_milli = 76;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getUpdateMilli = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 76, 0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setUpdateMilli = function(value) {
  jspb.Message.setProto3IntField(this, 76, value);
};


/**
 * optional uint64 position = 77;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 77, 0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPosition = function(value) {
  jspb.Message.setProto3IntField(this, 77, value);
};


/**
 * optional uint64 volume = 78;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 78, 0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolume = function(value) {
  jspb.Message.setProto3IntField(this, 78, value);
};


/**
 * optional uint32 volume_delta = 79;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeDelta = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 79, 0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeDelta = function(value) {
  jspb.Message.setProto3IntField(this, 79, value);
};


/**
 * optional double amount = 80;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getAmount = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 80, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setAmount = function(value) {
  jspb.Message.setProto3FloatField(this, 80, value);
};


/**
 * optional double amount_delta = 81;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getAmountDelta = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 81, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setAmountDelta = function(value) {
  jspb.Message.setProto3FloatField(this, 81, value);
};


/**
 * optional uint32 product_class = 82;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getProductClass = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 82, 0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setProductClass = function(value) {
  jspb.Message.setProto3IntField(this, 82, value);
};


/**
 * optional string target_code = 83;
 * @return {string}
 */
proto.vision.market.proto.Tick.prototype.getTargetCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 83, ""));
};


/** @param {string} value */
proto.vision.market.proto.Tick.prototype.setTargetCode = function(value) {
  jspb.Message.setProto3StringField(this, 83, value);
};


/**
 * optional uint32 stamp = 88;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getStamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 88, 0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setStamp = function(value) {
  jspb.Message.setProto3IntField(this, 88, value);
};


/**
 * optional uint32 source = 89;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getSource = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 89, 0));
};


/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setSource = function(value) {
  jspb.Message.setProto3IntField(this, 89, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.TickDelta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.TickDelta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.TickDelta.displayName = 'proto.vision.market.proto.TickDelta';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.TickDelta.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.TickDelta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.TickDelta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.TickDelta.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.TickDelta}
 */
proto.vision.market.proto.TickDelta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.TickDelta;
  return proto.vision.market.proto.TickDelta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.TickDelta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.TickDelta}
 */
proto.vision.market.proto.TickDelta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.TickDelta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.TickDelta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.TickDelta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.TickDelta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.Kbar = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.Kbar, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.Kbar.displayName = 'proto.vision.market.proto.Kbar';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.Kbar.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.Kbar.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.Kbar} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.Kbar.toObject = function(includeInstance, msg) {
  var f, obj = {
    targetId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    exchangeId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    ktype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    kunit: jspb.Message.getFieldWithDefault(msg, 4, 0),
    koption: jspb.Message.getFieldWithDefault(msg, 5, 0),
    kseq: jspb.Message.getFieldWithDefault(msg, 6, 0),
    stamp: jspb.Message.getFieldWithDefault(msg, 7, 0),
    time: jspb.Message.getFieldWithDefault(msg, 8, ""),
    tradingDay: jspb.Message.getFieldWithDefault(msg, 9, ""),
    updateDate: jspb.Message.getFieldWithDefault(msg, 10, ""),
    updateTime: jspb.Message.getFieldWithDefault(msg, 11, ""),
    priceOpen: +jspb.Message.getFieldWithDefault(msg, 12, 0.0),
    priceClose: +jspb.Message.getFieldWithDefault(msg, 13, 0.0),
    priceLow: +jspb.Message.getFieldWithDefault(msg, 14, 0.0),
    priceHigh: +jspb.Message.getFieldWithDefault(msg, 15, 0.0),
    priceSettlement: +jspb.Message.getFieldWithDefault(msg, 16, 0.0),
    priceAverage: +jspb.Message.getFieldWithDefault(msg, 17, 0.0),
    amount: +jspb.Message.getFieldWithDefault(msg, 18, 0.0),
    volume: jspb.Message.getFieldWithDefault(msg, 19, 0),
    volumeTick: jspb.Message.getFieldWithDefault(msg, 20, 0),
    position: jspb.Message.getFieldWithDefault(msg, 21, 0),
    targetCode: jspb.Message.getFieldWithDefault(msg, 22, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.Kbar}
 */
proto.vision.market.proto.Kbar.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.Kbar;
  return proto.vision.market.proto.Kbar.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.Kbar} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.Kbar}
 */
proto.vision.market.proto.Kbar.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExchangeId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setKtype(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setKunit(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setKoption(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setKseq(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStamp(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTime(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradingDay(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdateDate(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdateTime(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceOpen(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceClose(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceLow(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceHigh(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceSettlement(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceAverage(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setVolume(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setVolumeTick(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPosition(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.Kbar.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.Kbar.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.Kbar} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.Kbar.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExchangeId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getKtype();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getKunit();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getKoption();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getKseq();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getStamp();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getTime();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTradingDay();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUpdateDate();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getUpdateTime();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getPriceOpen();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getPriceClose();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getPriceLow();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getPriceHigh();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getPriceSettlement();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
  f = message.getPriceAverage();
  if (f !== 0.0) {
    writer.writeDouble(
      17,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      18,
      f
    );
  }
  f = message.getVolume();
  if (f !== 0) {
    writer.writeUint64(
      19,
      f
    );
  }
  f = message.getVolumeTick();
  if (f !== 0) {
    writer.writeUint64(
      20,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeUint64(
      21,
      f
    );
  }
  f = message.getTargetCode();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
};


/**
 * optional string target_id = 1;
 * @return {string}
 */
proto.vision.market.proto.Kbar.prototype.getTargetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.vision.market.proto.Kbar.prototype.setTargetId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 exchange_id = 2;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getExchangeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setExchangeId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 ktype = 3;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getKtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setKtype = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 kunit = 4;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getKunit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setKunit = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 koption = 5;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getKoption = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setKoption = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 kseq = 6;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getKseq = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setKseq = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 stamp = 7;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getStamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setStamp = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string time = 8;
 * @return {string}
 */
proto.vision.market.proto.Kbar.prototype.getTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.vision.market.proto.Kbar.prototype.setTime = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string trading_day = 9;
 * @return {string}
 */
proto.vision.market.proto.Kbar.prototype.getTradingDay = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.vision.market.proto.Kbar.prototype.setTradingDay = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string update_date = 10;
 * @return {string}
 */
proto.vision.market.proto.Kbar.prototype.getUpdateDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.vision.market.proto.Kbar.prototype.setUpdateDate = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string update_time = 11;
 * @return {string}
 */
proto.vision.market.proto.Kbar.prototype.getUpdateTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.vision.market.proto.Kbar.prototype.setUpdateTime = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional double price_open = 12;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getPriceOpen = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 12, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setPriceOpen = function(value) {
  jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional double price_close = 13;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getPriceClose = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 13, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setPriceClose = function(value) {
  jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional double price_low = 14;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getPriceLow = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 14, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setPriceLow = function(value) {
  jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional double price_high = 15;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getPriceHigh = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 15, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setPriceHigh = function(value) {
  jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional double price_settlement = 16;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getPriceSettlement = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 16, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setPriceSettlement = function(value) {
  jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional double price_average = 17;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getPriceAverage = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 17, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setPriceAverage = function(value) {
  jspb.Message.setProto3FloatField(this, 17, value);
};


/**
 * optional double amount = 18;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getAmount = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 18, 0.0));
};


/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setAmount = function(value) {
  jspb.Message.setProto3FloatField(this, 18, value);
};


/**
 * optional uint64 volume = 19;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setVolume = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional uint64 volume_tick = 20;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getVolumeTick = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setVolumeTick = function(value) {
  jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional uint64 position = 21;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setPosition = function(value) {
  jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional string target_code = 22;
 * @return {string}
 */
proto.vision.market.proto.Kbar.prototype.getTargetCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/** @param {string} value */
proto.vision.market.proto.Kbar.prototype.setTargetCode = function(value) {
  jspb.Message.setProto3StringField(this, 22, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.GetTick = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.GetTick, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.GetTick.displayName = 'proto.vision.market.proto.GetTick';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.GetTick.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.GetTick.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.GetTick} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetTick.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    targetId: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.GetTick}
 */
proto.vision.market.proto.GetTick.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.GetTick;
  return proto.vision.market.proto.GetTick.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.GetTick} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.GetTick}
 */
proto.vision.market.proto.GetTick.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUserId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.GetTick.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.GetTick.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.GetTick} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetTick.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getTargetId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional uint64 user_id = 1;
 * @return {number}
 */
proto.vision.market.proto.GetTick.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.vision.market.proto.GetTick.prototype.setUserId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string target_id = 10;
 * @return {string}
 */
proto.vision.market.proto.GetTick.prototype.getTargetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.vision.market.proto.GetTick.prototype.setTargetId = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.GetTickRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.GetTickRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.GetTickRsp.displayName = 'proto.vision.market.proto.GetTickRsp';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.GetTickRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.GetTickRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.GetTickRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetTickRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.vision.market.proto.Tick.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.GetTickRsp}
 */
proto.vision.market.proto.GetTickRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.GetTickRsp;
  return proto.vision.market.proto.GetTickRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.GetTickRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.GetTickRsp}
 */
proto.vision.market.proto.GetTickRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUserId(value);
      break;
    case 2:
      var value = new Object_pb.Error;
      reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 10:
      var value = new proto.vision.market.proto.Tick;
      reader.readMessage(value,proto.vision.market.proto.Tick.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.GetTickRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.GetTickRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.GetTickRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetTickRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      Object_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.vision.market.proto.Tick.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 user_id = 1;
 * @return {number}
 */
proto.vision.market.proto.GetTickRsp.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.vision.market.proto.GetTickRsp.prototype.setUserId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional proto.Error error = 2;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.GetTickRsp.prototype.getError = function() {
  return /** @type{?proto.proto.Error} */ (
    jspb.Message.getWrapperField(this, Object_pb.Error, 2));
};


/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.GetTickRsp.prototype.setError = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.vision.market.proto.GetTickRsp.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.GetTickRsp.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Tick data = 10;
 * @return {?proto.vision.market.proto.Tick}
 */
proto.vision.market.proto.GetTickRsp.prototype.getData = function() {
  return /** @type{?proto.vision.market.proto.Tick} */ (
    jspb.Message.getWrapperField(this, proto.vision.market.proto.Tick, 10));
};


/** @param {?proto.vision.market.proto.Tick|undefined} value */
proto.vision.market.proto.GetTickRsp.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 10, value);
};


proto.vision.market.proto.GetTickRsp.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.GetTickRsp.prototype.hasData = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.SubTick = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vision.market.proto.SubTick.repeatedFields_, null);
};
goog.inherits(proto.vision.market.proto.SubTick, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.SubTick.displayName = 'proto.vision.market.proto.SubTick';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vision.market.proto.SubTick.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.SubTick.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.SubTick.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.SubTick} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubTick.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    exchangeId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    productId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    targetIdList: jspb.Message.getRepeatedField(msg, 4)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.SubTick}
 */
proto.vision.market.proto.SubTick.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.SubTick;
  return proto.vision.market.proto.SubTick.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.SubTick} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.SubTick}
 */
proto.vision.market.proto.SubTick.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExchangeId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addTargetId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.SubTick.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.SubTick.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.SubTick} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubTick.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getExchangeId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTargetIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
};


/**
 * optional uint64 user_id = 1;
 * @return {number}
 */
proto.vision.market.proto.SubTick.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.vision.market.proto.SubTick.prototype.setUserId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 exchange_id = 2;
 * @return {number}
 */
proto.vision.market.proto.SubTick.prototype.getExchangeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.vision.market.proto.SubTick.prototype.setExchangeId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string product_id = 3;
 * @return {string}
 */
proto.vision.market.proto.SubTick.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.vision.market.proto.SubTick.prototype.setProductId = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string target_id = 4;
 * @return {!Array.<string>}
 */
proto.vision.market.proto.SubTick.prototype.getTargetIdList = function() {
  return /** @type {!Array.<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/** @param {!Array.<string>} value */
proto.vision.market.proto.SubTick.prototype.setTargetIdList = function(value) {
  jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.vision.market.proto.SubTick.prototype.addTargetId = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


proto.vision.market.proto.SubTick.prototype.clearTargetIdList = function() {
  this.setTargetIdList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.SubTickRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.SubTickRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.SubTickRsp.displayName = 'proto.vision.market.proto.SubTickRsp';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.SubTickRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.SubTickRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.SubTickRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubTickRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.vision.market.proto.SubTick.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.SubTickRsp}
 */
proto.vision.market.proto.SubTickRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.SubTickRsp;
  return proto.vision.market.proto.SubTickRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.SubTickRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.SubTickRsp}
 */
proto.vision.market.proto.SubTickRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new Object_pb.Error;
      reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 10:
      var value = new proto.vision.market.proto.SubTick;
      reader.readMessage(value,proto.vision.market.proto.SubTick.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.SubTickRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.SubTickRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.SubTickRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubTickRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      Object_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.vision.market.proto.SubTick.serializeBinaryToWriter
    );
  }
};


/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.SubTickRsp.prototype.getError = function() {
  return /** @type{?proto.proto.Error} */ (
    jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};


/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.SubTickRsp.prototype.setError = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.vision.market.proto.SubTickRsp.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.SubTickRsp.prototype.hasError = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SubTick data = 10;
 * @return {?proto.vision.market.proto.SubTick}
 */
proto.vision.market.proto.SubTickRsp.prototype.getData = function() {
  return /** @type{?proto.vision.market.proto.SubTick} */ (
    jspb.Message.getWrapperField(this, proto.vision.market.proto.SubTick, 10));
};


/** @param {?proto.vision.market.proto.SubTick|undefined} value */
proto.vision.market.proto.SubTickRsp.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 10, value);
};


proto.vision.market.proto.SubTickRsp.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.SubTickRsp.prototype.hasData = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.SubTickAll = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.SubTickAll, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.SubTickAll.displayName = 'proto.vision.market.proto.SubTickAll';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.SubTickAll.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.SubTickAll.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.SubTickAll} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubTickAll.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    productClass: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.SubTickAll}
 */
proto.vision.market.proto.SubTickAll.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.SubTickAll;
  return proto.vision.market.proto.SubTickAll.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.SubTickAll} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.SubTickAll}
 */
proto.vision.market.proto.SubTickAll.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setProductClass(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.SubTickAll.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.SubTickAll.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.SubTickAll} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubTickAll.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getProductClass();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional uint64 user_id = 1;
 * @return {number}
 */
proto.vision.market.proto.SubTickAll.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.vision.market.proto.SubTickAll.prototype.setUserId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 product_class = 2;
 * @return {number}
 */
proto.vision.market.proto.SubTickAll.prototype.getProductClass = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.vision.market.proto.SubTickAll.prototype.setProductClass = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.SubTickAllRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.SubTickAllRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.SubTickAllRsp.displayName = 'proto.vision.market.proto.SubTickAllRsp';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.SubTickAllRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.SubTickAllRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.SubTickAllRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubTickAllRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.vision.market.proto.SubTickAll.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.SubTickAllRsp}
 */
proto.vision.market.proto.SubTickAllRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.SubTickAllRsp;
  return proto.vision.market.proto.SubTickAllRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.SubTickAllRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.SubTickAllRsp}
 */
proto.vision.market.proto.SubTickAllRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new Object_pb.Error;
      reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 10:
      var value = new proto.vision.market.proto.SubTickAll;
      reader.readMessage(value,proto.vision.market.proto.SubTickAll.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.SubTickAllRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.SubTickAllRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.SubTickAllRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubTickAllRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      Object_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.vision.market.proto.SubTickAll.serializeBinaryToWriter
    );
  }
};


/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.SubTickAllRsp.prototype.getError = function() {
  return /** @type{?proto.proto.Error} */ (
    jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};


/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.SubTickAllRsp.prototype.setError = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.vision.market.proto.SubTickAllRsp.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.SubTickAllRsp.prototype.hasError = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SubTickAll data = 10;
 * @return {?proto.vision.market.proto.SubTickAll}
 */
proto.vision.market.proto.SubTickAllRsp.prototype.getData = function() {
  return /** @type{?proto.vision.market.proto.SubTickAll} */ (
    jspb.Message.getWrapperField(this, proto.vision.market.proto.SubTickAll, 10));
};


/** @param {?proto.vision.market.proto.SubTickAll|undefined} value */
proto.vision.market.proto.SubTickAllRsp.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 10, value);
};


proto.vision.market.proto.SubTickAllRsp.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.SubTickAllRsp.prototype.hasData = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.SubKbar = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.SubKbar, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.SubKbar.displayName = 'proto.vision.market.proto.SubKbar';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.SubKbar.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.SubKbar.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.SubKbar} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubKbar.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    targetId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    exchangeId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ktype: jspb.Message.getFieldWithDefault(msg, 4, 0),
    kunit: jspb.Message.getFieldWithDefault(msg, 5, 0),
    koption: jspb.Message.getFieldWithDefault(msg, 6, 0),
    kquery: jspb.Message.getFieldWithDefault(msg, 7, 0),
    ksize: jspb.Message.getFieldWithDefault(msg, 8, 0),
    startTime: jspb.Message.getFieldWithDefault(msg, 9, ""),
    endTime: jspb.Message.getFieldWithDefault(msg, 10, ""),
    targetCode: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.SubKbar}
 */
proto.vision.market.proto.SubKbar.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.SubKbar;
  return proto.vision.market.proto.SubKbar.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.SubKbar} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.SubKbar}
 */
proto.vision.market.proto.SubKbar.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExchangeId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setKtype(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setKunit(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setKoption(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setKquery(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setKsize(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartTime(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndTime(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.SubKbar.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.SubKbar.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.SubKbar} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubKbar.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getTargetId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExchangeId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getKtype();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getKunit();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getKoption();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getKquery();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getKsize();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getStartTime();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getEndTime();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTargetCode();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional uint64 user_id = 1;
 * @return {number}
 */
proto.vision.market.proto.SubKbar.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.vision.market.proto.SubKbar.prototype.setUserId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string target_id = 2;
 * @return {string}
 */
proto.vision.market.proto.SubKbar.prototype.getTargetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.vision.market.proto.SubKbar.prototype.setTargetId = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 exchange_id = 3;
 * @return {number}
 */
proto.vision.market.proto.SubKbar.prototype.getExchangeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.vision.market.proto.SubKbar.prototype.setExchangeId = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 ktype = 4;
 * @return {number}
 */
proto.vision.market.proto.SubKbar.prototype.getKtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.vision.market.proto.SubKbar.prototype.setKtype = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 kunit = 5;
 * @return {number}
 */
proto.vision.market.proto.SubKbar.prototype.getKunit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.vision.market.proto.SubKbar.prototype.setKunit = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 koption = 6;
 * @return {number}
 */
proto.vision.market.proto.SubKbar.prototype.getKoption = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.vision.market.proto.SubKbar.prototype.setKoption = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 kquery = 7;
 * @return {number}
 */
proto.vision.market.proto.SubKbar.prototype.getKquery = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.vision.market.proto.SubKbar.prototype.setKquery = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 ksize = 8;
 * @return {number}
 */
proto.vision.market.proto.SubKbar.prototype.getKsize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.vision.market.proto.SubKbar.prototype.setKsize = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string start_time = 9;
 * @return {string}
 */
proto.vision.market.proto.SubKbar.prototype.getStartTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.vision.market.proto.SubKbar.prototype.setStartTime = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string end_time = 10;
 * @return {string}
 */
proto.vision.market.proto.SubKbar.prototype.getEndTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.vision.market.proto.SubKbar.prototype.setEndTime = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string target_code = 11;
 * @return {string}
 */
proto.vision.market.proto.SubKbar.prototype.getTargetCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.vision.market.proto.SubKbar.prototype.setTargetCode = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.SubKbarRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.SubKbarRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.SubKbarRsp.displayName = 'proto.vision.market.proto.SubKbarRsp';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.SubKbarRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.SubKbarRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.SubKbarRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubKbarRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.vision.market.proto.SubKbar.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.SubKbarRsp}
 */
proto.vision.market.proto.SubKbarRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.SubKbarRsp;
  return proto.vision.market.proto.SubKbarRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.SubKbarRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.SubKbarRsp}
 */
proto.vision.market.proto.SubKbarRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new Object_pb.Error;
      reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 10:
      var value = new proto.vision.market.proto.SubKbar;
      reader.readMessage(value,proto.vision.market.proto.SubKbar.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.SubKbarRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.SubKbarRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.SubKbarRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubKbarRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      Object_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.vision.market.proto.SubKbar.serializeBinaryToWriter
    );
  }
};


/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.SubKbarRsp.prototype.getError = function() {
  return /** @type{?proto.proto.Error} */ (
    jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};


/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.SubKbarRsp.prototype.setError = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.vision.market.proto.SubKbarRsp.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.SubKbarRsp.prototype.hasError = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SubKbar data = 10;
 * @return {?proto.vision.market.proto.SubKbar}
 */
proto.vision.market.proto.SubKbarRsp.prototype.getData = function() {
  return /** @type{?proto.vision.market.proto.SubKbar} */ (
    jspb.Message.getWrapperField(this, proto.vision.market.proto.SubKbar, 10));
};


/** @param {?proto.vision.market.proto.SubKbar|undefined} value */
proto.vision.market.proto.SubKbarRsp.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 10, value);
};


proto.vision.market.proto.SubKbarRsp.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.SubKbarRsp.prototype.hasData = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.GetBaseKbar = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.GetBaseKbar, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.GetBaseKbar.displayName = 'proto.vision.market.proto.GetBaseKbar';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.GetBaseKbar.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.GetBaseKbar.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.GetBaseKbar} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetBaseKbar.toObject = function(includeInstance, msg) {
  var f, obj = {
    targetCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ktype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    startTime: jspb.Message.getFieldWithDefault(msg, 3, ""),
    endTime: jspb.Message.getFieldWithDefault(msg, 4, ""),
    timeCond: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.GetBaseKbar}
 */
proto.vision.market.proto.GetBaseKbar.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.GetBaseKbar;
  return proto.vision.market.proto.GetBaseKbar.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.GetBaseKbar} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.GetBaseKbar}
 */
proto.vision.market.proto.GetBaseKbar.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setKtype(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartTime(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndTime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTimeCond(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.GetBaseKbar.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.GetBaseKbar.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.GetBaseKbar} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetBaseKbar.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getKtype();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getStartTime();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEndTime();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTimeCond();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional string target_code = 1;
 * @return {string}
 */
proto.vision.market.proto.GetBaseKbar.prototype.getTargetCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.vision.market.proto.GetBaseKbar.prototype.setTargetCode = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 ktype = 2;
 * @return {number}
 */
proto.vision.market.proto.GetBaseKbar.prototype.getKtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.vision.market.proto.GetBaseKbar.prototype.setKtype = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string start_time = 3;
 * @return {string}
 */
proto.vision.market.proto.GetBaseKbar.prototype.getStartTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.vision.market.proto.GetBaseKbar.prototype.setStartTime = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string end_time = 4;
 * @return {string}
 */
proto.vision.market.proto.GetBaseKbar.prototype.getEndTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.vision.market.proto.GetBaseKbar.prototype.setEndTime = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 time_cond = 5;
 * @return {number}
 */
proto.vision.market.proto.GetBaseKbar.prototype.getTimeCond = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.vision.market.proto.GetBaseKbar.prototype.setTimeCond = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.GetLastDayKbar = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.GetLastDayKbar, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.GetLastDayKbar.displayName = 'proto.vision.market.proto.GetLastDayKbar';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.GetLastDayKbar.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.GetLastDayKbar.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.GetLastDayKbar} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetLastDayKbar.toObject = function(includeInstance, msg) {
  var f, obj = {
    targetCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ktype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    volume: jspb.Message.getFieldWithDefault(msg, 3, 0),
    endTime: jspb.Message.getFieldWithDefault(msg, 4, ""),
    tradingDay: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.GetLastDayKbar}
 */
proto.vision.market.proto.GetLastDayKbar.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.GetLastDayKbar;
  return proto.vision.market.proto.GetLastDayKbar.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.GetLastDayKbar} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.GetLastDayKbar}
 */
proto.vision.market.proto.GetLastDayKbar.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setKtype(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setVolume(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndTime(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradingDay(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.GetLastDayKbar.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.GetLastDayKbar.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.GetLastDayKbar} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetLastDayKbar.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getKtype();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getVolume();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getEndTime();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTradingDay();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string target_code = 1;
 * @return {string}
 */
proto.vision.market.proto.GetLastDayKbar.prototype.getTargetCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.vision.market.proto.GetLastDayKbar.prototype.setTargetCode = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 ktype = 2;
 * @return {number}
 */
proto.vision.market.proto.GetLastDayKbar.prototype.getKtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.vision.market.proto.GetLastDayKbar.prototype.setKtype = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 volume = 3;
 * @return {number}
 */
proto.vision.market.proto.GetLastDayKbar.prototype.getVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.vision.market.proto.GetLastDayKbar.prototype.setVolume = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string end_time = 4;
 * @return {string}
 */
proto.vision.market.proto.GetLastDayKbar.prototype.getEndTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.vision.market.proto.GetLastDayKbar.prototype.setEndTime = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string trading_day = 5;
 * @return {string}
 */
proto.vision.market.proto.GetLastDayKbar.prototype.getTradingDay = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.vision.market.proto.GetLastDayKbar.prototype.setTradingDay = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.GetKbarRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.GetKbarRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.GetKbarRsp.displayName = 'proto.vision.market.proto.GetKbarRsp';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.GetKbarRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.GetKbarRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.GetKbarRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetKbarRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.vision.market.proto.Kbar.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.GetKbarRsp}
 */
proto.vision.market.proto.GetKbarRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.GetKbarRsp;
  return proto.vision.market.proto.GetKbarRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.GetKbarRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.GetKbarRsp}
 */
proto.vision.market.proto.GetKbarRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new Object_pb.Error;
      reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 10:
      var value = new proto.vision.market.proto.Kbar;
      reader.readMessage(value,proto.vision.market.proto.Kbar.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.GetKbarRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.GetKbarRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.GetKbarRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetKbarRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      Object_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.vision.market.proto.Kbar.serializeBinaryToWriter
    );
  }
};


/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.GetKbarRsp.prototype.getError = function() {
  return /** @type{?proto.proto.Error} */ (
    jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};


/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.GetKbarRsp.prototype.setError = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.vision.market.proto.GetKbarRsp.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.GetKbarRsp.prototype.hasError = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Kbar data = 10;
 * @return {?proto.vision.market.proto.Kbar}
 */
proto.vision.market.proto.GetKbarRsp.prototype.getData = function() {
  return /** @type{?proto.vision.market.proto.Kbar} */ (
    jspb.Message.getWrapperField(this, proto.vision.market.proto.Kbar, 10));
};


/** @param {?proto.vision.market.proto.Kbar|undefined} value */
proto.vision.market.proto.GetKbarRsp.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 10, value);
};


proto.vision.market.proto.GetKbarRsp.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.GetKbarRsp.prototype.hasData = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.TimeSeq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.TimeSeq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.TimeSeq.displayName = 'proto.vision.market.proto.TimeSeq';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.TimeSeq.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.TimeSeq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.TimeSeq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.TimeSeq.toObject = function(includeInstance, msg) {
  var f, obj = {
    time: jspb.Message.getFieldWithDefault(msg, 1, ""),
    seq: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.TimeSeq}
 */
proto.vision.market.proto.TimeSeq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.TimeSeq;
  return proto.vision.market.proto.TimeSeq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.TimeSeq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.TimeSeq}
 */
proto.vision.market.proto.TimeSeq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSeq(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.TimeSeq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.TimeSeq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.TimeSeq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.TimeSeq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTime();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSeq();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional string time = 1;
 * @return {string}
 */
proto.vision.market.proto.TimeSeq.prototype.getTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.vision.market.proto.TimeSeq.prototype.setTime = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 seq = 2;
 * @return {number}
 */
proto.vision.market.proto.TimeSeq.prototype.getSeq = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.vision.market.proto.TimeSeq.prototype.setSeq = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.TimeSeqReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.TimeSeqReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.TimeSeqReq.displayName = 'proto.vision.market.proto.TimeSeqReq';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.TimeSeqReq.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.TimeSeqReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.TimeSeqReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.TimeSeqReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    targetId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tradingDay: jspb.Message.getFieldWithDefault(msg, 2, ""),
    ktype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    kunit: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.TimeSeqReq}
 */
proto.vision.market.proto.TimeSeqReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.TimeSeqReq;
  return proto.vision.market.proto.TimeSeqReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.TimeSeqReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.TimeSeqReq}
 */
proto.vision.market.proto.TimeSeqReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradingDay(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setKtype(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setKunit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.TimeSeqReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.TimeSeqReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.TimeSeqReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.TimeSeqReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTradingDay();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getKtype();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getKunit();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional string target_id = 1;
 * @return {string}
 */
proto.vision.market.proto.TimeSeqReq.prototype.getTargetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.vision.market.proto.TimeSeqReq.prototype.setTargetId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string trading_day = 2;
 * @return {string}
 */
proto.vision.market.proto.TimeSeqReq.prototype.getTradingDay = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.vision.market.proto.TimeSeqReq.prototype.setTradingDay = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 ktype = 3;
 * @return {number}
 */
proto.vision.market.proto.TimeSeqReq.prototype.getKtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.vision.market.proto.TimeSeqReq.prototype.setKtype = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 kunit = 4;
 * @return {number}
 */
proto.vision.market.proto.TimeSeqReq.prototype.getKunit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.vision.market.proto.TimeSeqReq.prototype.setKunit = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.TimeSeqSet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vision.market.proto.TimeSeqSet.repeatedFields_, null);
};
goog.inherits(proto.vision.market.proto.TimeSeqSet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.TimeSeqSet.displayName = 'proto.vision.market.proto.TimeSeqSet';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vision.market.proto.TimeSeqSet.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.TimeSeqSet.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.TimeSeqSet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.TimeSeqSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.TimeSeqSet.toObject = function(includeInstance, msg) {
  var f, obj = {
    req: (f = msg.getReq()) && proto.vision.market.proto.TimeSeqReq.toObject(includeInstance, f),
    timeSeqList: jspb.Message.toObjectList(msg.getTimeSeqList(),
    proto.vision.market.proto.TimeSeq.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.TimeSeqSet}
 */
proto.vision.market.proto.TimeSeqSet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.TimeSeqSet;
  return proto.vision.market.proto.TimeSeqSet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.TimeSeqSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.TimeSeqSet}
 */
proto.vision.market.proto.TimeSeqSet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vision.market.proto.TimeSeqReq;
      reader.readMessage(value,proto.vision.market.proto.TimeSeqReq.deserializeBinaryFromReader);
      msg.setReq(value);
      break;
    case 2:
      var value = new proto.vision.market.proto.TimeSeq;
      reader.readMessage(value,proto.vision.market.proto.TimeSeq.deserializeBinaryFromReader);
      msg.addTimeSeq(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.TimeSeqSet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.TimeSeqSet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.TimeSeqSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.TimeSeqSet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReq();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vision.market.proto.TimeSeqReq.serializeBinaryToWriter
    );
  }
  f = message.getTimeSeqList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.vision.market.proto.TimeSeq.serializeBinaryToWriter
    );
  }
};


/**
 * optional TimeSeqReq req = 1;
 * @return {?proto.vision.market.proto.TimeSeqReq}
 */
proto.vision.market.proto.TimeSeqSet.prototype.getReq = function() {
  return /** @type{?proto.vision.market.proto.TimeSeqReq} */ (
    jspb.Message.getWrapperField(this, proto.vision.market.proto.TimeSeqReq, 1));
};


/** @param {?proto.vision.market.proto.TimeSeqReq|undefined} value */
proto.vision.market.proto.TimeSeqSet.prototype.setReq = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.vision.market.proto.TimeSeqSet.prototype.clearReq = function() {
  this.setReq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.TimeSeqSet.prototype.hasReq = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated TimeSeq time_seq = 2;
 * @return {!Array.<!proto.vision.market.proto.TimeSeq>}
 */
proto.vision.market.proto.TimeSeqSet.prototype.getTimeSeqList = function() {
  return /** @type{!Array.<!proto.vision.market.proto.TimeSeq>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vision.market.proto.TimeSeq, 2));
};


/** @param {!Array.<!proto.vision.market.proto.TimeSeq>} value */
proto.vision.market.proto.TimeSeqSet.prototype.setTimeSeqList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.vision.market.proto.TimeSeq=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vision.market.proto.TimeSeq}
 */
proto.vision.market.proto.TimeSeqSet.prototype.addTimeSeq = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.vision.market.proto.TimeSeq, opt_index);
};


proto.vision.market.proto.TimeSeqSet.prototype.clearTimeSeqList = function() {
  this.setTimeSeqList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.TimeSeqRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.TimeSeqRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.TimeSeqRsp.displayName = 'proto.vision.market.proto.TimeSeqRsp';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vision.market.proto.TimeSeqRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.vision.market.proto.TimeSeqRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vision.market.proto.TimeSeqRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.TimeSeqRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.vision.market.proto.TimeSeqSet.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.TimeSeqRsp}
 */
proto.vision.market.proto.TimeSeqRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.TimeSeqRsp;
  return proto.vision.market.proto.TimeSeqRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.TimeSeqRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.TimeSeqRsp}
 */
proto.vision.market.proto.TimeSeqRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new Object_pb.Error;
      reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 10:
      var value = new proto.vision.market.proto.TimeSeqSet;
      reader.readMessage(value,proto.vision.market.proto.TimeSeqSet.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.TimeSeqRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.TimeSeqRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.TimeSeqRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.TimeSeqRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      Object_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.vision.market.proto.TimeSeqSet.serializeBinaryToWriter
    );
  }
};


/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.TimeSeqRsp.prototype.getError = function() {
  return /** @type{?proto.proto.Error} */ (
    jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};


/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.TimeSeqRsp.prototype.setError = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.vision.market.proto.TimeSeqRsp.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.TimeSeqRsp.prototype.hasError = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TimeSeqSet data = 10;
 * @return {?proto.vision.market.proto.TimeSeqSet}
 */
proto.vision.market.proto.TimeSeqRsp.prototype.getData = function() {
  return /** @type{?proto.vision.market.proto.TimeSeqSet} */ (
    jspb.Message.getWrapperField(this, proto.vision.market.proto.TimeSeqSet, 10));
};


/** @param {?proto.vision.market.proto.TimeSeqSet|undefined} value */
proto.vision.market.proto.TimeSeqRsp.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 10, value);
};


proto.vision.market.proto.TimeSeqRsp.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.TimeSeqRsp.prototype.hasData = function() {
  return jspb.Message.getField(this, 10) != null;
};


goog.object.extend(exports, proto.vision.market.proto);



//////////////////
// WEBPACK FOOTER
// ./static/js/proto/Market_pb.js
// module id = cdwa
// module chunks = 2